export enum DashboardIPOsOnMoveWidgetBlock {
  Root = 'DashboardIPOsOnMoveWidget',
}

export enum DashboardIPOsOnMoveWidgetElement {
  Toolbar = 'toolbar',
}
